<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">

        <!-- TARJETA DE FILTROS -->
        <div class="card mb-3 shadow-sm">
          <div class="card-body p-3">
            <div class="row align-items-end">
              <div class="col-md-3 col-sm-6 mb-2">
                <label class="text-xxs font-weight-bolder opacity-7 text-uppercase">Buscar Descripción</label>
                <!-- Este input filtrará en el Front-End en tiempo real -->
                <input v-model="filters.search" type="text" class="form-control form-control-sm" placeholder="Ej: Cobro a cliente...">
              </div>
              <div class="col-md-2 col-sm-6 mb-2">
                <label class="text-xxs font-weight-bolder opacity-7 text-uppercase">Tipo de Tarea</label>
                <select v-model="filters.task_type_id" class="form-select form-select-sm">
                  <option value="">Todos los tipos</option>
                  <option v-for="t in taskTypes" :key="t.id" :value="t.name">{{ t.name }}</option>
                </select>
              </div>
              <div class="col-md-2 col-sm-6 mb-2">
                <label class="text-xxs font-weight-bolder opacity-7 text-uppercase">Asignado a</label>
                <select v-model="filters.assigned_to" class="form-select form-select-sm">
                  <option value="">Todos los usuarios</option>
                  <option v-for="u in users" :key="u.id" :value="u.id">{{ u.full_name }}</option>
                </select>
              </div>
              <div class="col-md-2 col-sm-6 mb-2">
                <label class="text-xxs font-weight-bolder opacity-7 text-uppercase">Estado</label>
                <select v-model="filters.status" class="form-select form-select-sm">
                  <option value="">Todos</option>
                  <option value="Pending">Pendiente</option>
                  <option value="Completed">Completado</option>
                  <option value="In Progress">En Progreso</option>
                </select>
              </div>
              <div class="col-md-2 col-sm-6 mb-2">
                <label class="text-xxs font-weight-bolder opacity-7 text-uppercase">Fecha Venc.</label>
                <input v-model="filters.due_date" type="date" class="form-control form-control-sm">
              </div>

              <!-- BOTONERA DE BÚSQUEDA -->
              <div class="col-md-12 mt-2 d-flex justify-content-end gap-2">
                <button class="btn btn-sm btn-outline-secondary mb-0" @click="resetFilters" :disabled="isLoading">
                  <i class="fa fa-sync me-1"></i> Limpiar
                </button>
                <button class="btn btn-sm bg-success mb-0 text-white" @click="fetchTasks" :disabled="isLoading">
                  <i class="fa fa-search me-1"></i> Buscar Tareas
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- LISTADO DE TAREAS -->
        <div class="card mb-4">
          <div class="card-header pb-0 d-flex justify-content-between align-items-center">
            <!-- Actualizado a displayedTasks -->
            <h6>Listado Maestro ({{ displayedTasks.length }} resultados)</h6>
            <argon-button color="success" size="sm" @click="$router.push('/tasks/create')">
              <i class="fa fa-plus me-1"></i> Nueva Tarea
            </argon-button>
          </div>
          <div class="card-body px-0 pt-0 pb-2">

            <div v-if="isLoading" class="p-4 text-center">
              <div class="spinner-border text-primary" role="status"></div>
              <p class="mt-2 text-sm text-secondary">Consultando servidor...</p>
            </div>

            <div v-else class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7">Tarea / Tipo</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 ps-2">Asignado a</th>
                    <th class="text-center text-uppercase text-xxs font-weight-bolder opacity-7">Prioridad</th>
                    <th class="text-center text-uppercase text-xxs font-weight-bolder opacity-7">Estado</th>
                    <th class="text-center text-uppercase text-xxs font-weight-bolder opacity-7">Vencimiento</th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Actualizado a displayedTasks -->
                  <tr v-for="task in displayedTasks" :key="task.id">
                    <td>
                      <div class="d-flex px-3 py-1">
                        <div>
                          <div :class="['icon icon-shape icon-sm me-3 shadow text-center d-flex align-items-center justify-content-center border-radius-md', priorityBg(task.priority)]">
                            <i :class="[taskTypeIcon(task.type_name), 'text-white opacity-10']"></i>
                          </div>
                        </div>
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ task.task_description || task.description }}</h6>
                          <p class="text-xs text-secondary mb-0 text-uppercase font-weight-bold">{{ task.type_name }}</p>
                          <small v-if="task.type_name=='Cobranza'">Monto a cobrar: {{ task.to_collect }} / Monto cobrado: {{task.collected  }} </small>
                          <small v-if="task.self==1" class="text-xs text-success"><strong>Autoasignada</strong></small>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        <div class="avatar avatar-xs me-2 bg-gradient-dark border-radius-sm">
                          <span class="text-xxs">{{ getInitials(task.employee_name || task.assigned_to_name) }}</span>
                        </div>
                        <span class="text-xs font-weight-bold">{{ task.employee_name || task.assigned_to_name || 'Sin Asignar' }}</span>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span :class="['badge badge-sm', priorityBadge(task.priority)]">{{ task.priority }}</span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        <i :class="['fa fa-circle me-1', statusTextColor(task.status)]" style="font-size: 8px;"></i>
                        {{ task.status }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span :class="['text-xs font-weight-bold', isOverdue(task.due_date) ? 'text-danger' : 'text-secondary']">
                        {{ task.due_date || 'Sin fecha' }}
                      </span>
                    </td>
                    <td class="align-middle">
                      <button v-if="task.status!='Completed'" class="btn btn-link text-primary mb-0" @click="editTask(task.id)">
                        <i class="fa fa-pen text-xs"></i>
                      </button>
                       <button class="btn btn-link text-primary mb-0" @click="revTask(task.id)">
                        <i class="fa fa-eye text-xs"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- Actualizado a displayedTasks -->
              <div v-if="displayedTasks.length === 0" class="text-center p-4">
                <p class="text-sm text-secondary">
                  Utilice los filtros arriba y presione "Buscar Tareas" para cargar información.
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import ArgonButton from "@/components/ArgonButton.vue";
import axios from "axios";
import moment from "moment";

export default {
  name: "TasksIndex",
  components: { ArgonButton },
  data() {
    return {
      tasks: [],
      taskTypes: [], // Lista dinámica de tipos
      users: [],     // Lista dinámica de usuarios
      isLoading: false,
      companyId: localStorage.getItem('companyId'),
      // OBJETOS DE FILTRO ALINEADOS A LAS COLUMNAS DE DB
      filters: {
        search: '',
        task_type_id: '',
        assigned_to: '',
        status: '',
        due_date: ''
      }
    };
  },
  computed: {
    // FILTRO FRONT-END EN TIEMPO REAL POR DESCRIPCIÓN, TIPO Y ESTADO
    displayedTasks() {
      const searchTerm = this.filters.search ? this.filters.search.toLowerCase() : '';
      const filterType = this.filters.task_type_id;
      const filterStatus = this.filters.status;

      return this.tasks.filter(task => {
        // 1. Filtro de Búsqueda (Descripción)
        let matchesSearch = true;
        if (searchTerm) {
          const desc = task.task_description || task.description || '';
          matchesSearch = desc.toLowerCase().includes(searchTerm);
        }

        // 2. Filtro de Tipo de Tarea (usando == para evitar problemas string/int)
        let matchesType = true;
        if (filterType) {
          matchesType = (task.type_name == filterType);
        }

        // 3. Filtro de Estado
        let matchesStatus = true;
        if (filterStatus) {
          matchesStatus = (task.status === filterStatus);
        }

        return matchesSearch && matchesType && matchesStatus;
      });
    }
  },
  methods: {
    resetFilters() {
      this.filters = { search: '', task_type_id: '', assigned_to: '', status: '', due_date: '' };
      this.tasks = []; // Opcional: Limpiar la tabla al resetear
    },

    // 1. CARGA DINÁMICA DE CATÁLOGOS SEGÚN PERMISOS
    async loadCatalogs() {
      const token = localStorage.getItem("accessToken");
      const headers = { 'Authorization': `Bearer ${token}` };
      const roleId = parseInt(localStorage.getItem('userLevel'));
      const branchId = localStorage.getItem('branchId');

      try {
        // Cargar Tipos de Tarea
        const resTypes = await axios.get(`${this.$store.state.apiURL}task_type`, { headers });
        this.taskTypes = resTypes.data;

        // Cargar Usuarios aplicando regla de sucursal
        let userParams = {};
        if (roleId === 2 && branchId && branchId !== 'null') {
          userParams.fk_branch_id  = branchId;
        }
        const resUsers = await axios.get(`${this.$store.state.apiURL}users`, { params: userParams, headers });
        this.users = resUsers.data;
      } catch (error) {
        console.error("Error cargando catálogos:", error);
      }
    },

    // 2. BÚSQUEDA A DEMANDA HACIA EL SERVIDOR
    async fetchTasks() {
      this.isLoading = true;
      const token = localStorage.getItem("accessToken");

      try {
        // Construimos los query params excluyendo los que estén vacíos
        const queryParams = {
          company_id: this.companyId,
          type: 'user_detail' // Mantenemos el scope del reporte para que haga los JOINs de nombres
        };

        // Inyectar solo los filtros que el usuario haya seleccionado (El search también puede ir por si tu API lo soporta)
        if (this.filters.search) queryParams.search = this.filters.search;
        if (this.filters.task_type_id) queryParams.task_type_id = this.filters.task_type_id;
        if (this.filters.assigned_to) queryParams.user_id = this.filters.assigned_to;
        if (this.filters.status) queryParams.status = this.filters.status;
        if (this.filters.due_date) queryParams.start_date = this.filters.due_date;
        if (this.filters.due_date) queryParams.end_date = this.filters.due_date;

        const response = await axios.get(`${this.$store.state.apiURL}reports/tasks`, {
          params: queryParams,
          headers: { 'Authorization': `Bearer ${token}` }
        });

        this.tasks = response.data;
      } catch (error) {
        console.error("Error obteniendo tareas:", error);
      } finally {
        this.isLoading = false;
      }
    },

    // UI Helpers (Sin cambios)
    taskTypeIcon(name) {
      const n = name ? name.toLowerCase() : '';
      if (n.includes('cobro')) return 'fa fa-money-bill-wave';
      if (n.includes('entrega')) return 'fa fa-truck';
      if (n.includes('visita')) return 'fa fa-map-marker-alt';
      if (n.includes('credito')) return 'fa fa-credit-card';
      return 'fa fa-tasks';
    },
    priorityBg(p) {
      if (p === 'High') return 'bg-gradient-danger';
      if (p === 'Medium') return 'bg-gradient-warning';
      return 'bg-gradient-info';
    },
    priorityBadge(p) {
      if (p === 'High') return 'badge-danger';
      if (p === 'Medium') return 'badge-warning';
      return 'badge-info';
    },
    statusTextColor(s) {
      if (s === 'Completed') return 'text-success';
      if (s === 'In Progress') return 'text-info';
      if (s === 'Canceled') return 'text-danger';
      return 'text-warning';
    },
    isOverdue(date) {
      if (!date || date === '0000-00-00') return false;
      return moment(date).isBefore(moment(), 'day');
    },
    getInitials(name) {
      if (!name) return "SA";
      return name.split(" ").map(n => n[0]).slice(0, 2).join("").toUpperCase();
    },
    editTask(id) {
      this.$router.push({ name: 'Editar Tarea', params: { id } });
    },
    revTask(id) {
      this.$router.push({ name: 'Revisar Tarea', params: { id } });
    }
  },
  async mounted() {
    await this.loadCatalogs();

    // Configura la fecha de hoy por defecto
    this.filters.due_date = moment().format('YYYY-MM-DD');

    // Llama a la API de inmediato
    this.fetchTasks();
  }
};
</script>